// Demo is the default. Set REACT_APP_DEMO_MODE=false to use the backend.
export const DEMO_MODE = process.env.REACT_APP_DEMO_MODE !== 'false';
export const ENV = 'PROD';
export const AUTHENTICATION_FAILED = 'Authentication Failed';

export const THEME_COLOR = '#5a8dee';
export const THEME_COLOR2 = '#f3f4f4';
export const THEME_COLOR3 = '#677788';
export const LABEL_COLOR = '#008000';

// Never expose the production clinic identity in a demo build. Live mode keeps
// the original invoice identity for the real API-backed application.
export const GST = DEMO_MODE ? '00DEMO0000D0Z0' : '32ASDPJ3313Q1ZS';
export const CLINIC_ADDRESS = DEMO_MODE
  ? '123 Sample Street, Demo District.'
  : 'Behind Indira Gandhi Cooperative Hospital, Subash Road, Kadavanthara.';
export const CLINIC_ADDRESS2 = DEMO_MODE ? 'Demo City - 000000' : 'Kochi - 682020';
export const CLINIC_MOBILE = DEMO_MODE ? '+91 90000 00000' : '+91 95910 76990';

export const UTC_OFFSET = "+05:30";

export const NAVBAR_HEIGHT = 64;
export const FOOTER_HEIGHT = 40;

export const APPOINTMENT_TIME_DIFF_VAL = 45;
export const APPOINTMENT_TIME_DIFF_TYPE = 'minutes';

export const APPOINTMENT_TITLE = [
  {
    label: 'Speech Therapy',
    value: 'ST',
    fee: 600,
  },
  {
    label: 'Occupational Therapy',
    value: 'OT',
    fee: 600,
  }
]


export const APPOINTMENT_COLOR = [
  {
    bgColor: '#dff9ec',
    textColor: '#33b679',
    dotColor: '#33b679',
  },
  {
    bgColor: '#8f25aa',
    textColor: '#fff',
    dotColor: '#8f25aa',
  },
];
